<!-- 左上角 -->
<template>
    <div class='bg box box_v' ref="overview_card1">
        <div class="title1">各区县实名认证数</div>
        <div class="box title_right">
            <div class="title2">实名认证总数</div>
            <div class="title3">{{total}}</div>
            <div class="title2">人</div>
        </div>
        <div class="tr box" :style="'height:'+height">
            <div id="overview_scroll_wrapper" 
                class="scroll_wrapper"
                :style="'height:'+contentheight+';marginTop:'+marginTop">
                <div class="box box_between tr_item_wrapper" v-for="item in list" :key="item.areaName">
                    <div class="tr_item_title1">{{item.areaName}}</div>
                    <div class="box">
                        <div class="tr_item_title2">{{item.realNameCount}}</div>
                        <div class="tr_item_title3">{{item.label}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            list:[],
            total:null,
            height:'100%',
            contentheight:'100%',
            timer:null,
            num:1,
            marginTop:'0px'
        };
    },
    props:{
        show:{
            type:Boolean,
            default:false
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        show:{
            handler(newVal){
                if(newVal){
                    this.list=[]
                    this.marginTop ='0px' 
                    this.getData()
                }else{
                    this.timer && clearInterval(this.timer)
                }
            },
            immediate:true
        }
    },
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.realnameCount).then(res=>{
                this.list = res.rows.map(item=>{
                    return{
                        areaName:item.areaName,
                        realNameCount:item.realNameCount>10000?(item.realNameCount/10000).toFixed(2):item.realNameCount,
                        label:item.realNameCount>10000?'万':''
                    }
                })
                this.total = Number(res.newPrimaryKeys.realNameTotalCount).toLocaleString()
                
                //处理样式，超过8个轮播
               
                let height = this.$refs.overview_card1.offsetHeight - 60
                this.height =  height+ 'px'
                
                let num = 1
                //let itemHeight = height/4-10 
                let itemHeight = 40
                let contentheight = Math.ceil(res.rows.length/2) * (itemHeight+10)
                this.contentheight = contentheight + 'px'
                console.log(contentheight)
                 console.log(height)
                
                if(this.height<this.contentheight){
                    //没有显示完整
                    this.timer = setInterval(()=>{
                        if(num*(itemHeight+12)<=contentheight){
                            console.log(num*(itemHeight+10))
                            this.marginTop ='-'+(num*(itemHeight+10))+'px'  
                            num++
                        }else{
                            num = 1
                            this.marginTop ='-'+(num*(itemHeight+10))+'px'  
                        }
                    },3000)
                }
                
            }).catch(e=>{

            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {
       
    }, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.bg{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/leftup.png');
    background-size: 100% 100%;
    margin-bottom:10px;
    height:100%;
}
.title1{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin:30px 0 0 50px
}
.title_right{
    justify-content: flex-end;
    margin-right:20px;
    margin-top:-20px;
}
.title2{
    font-size: 14px;
    color: #FF9941;
    margin-top:14px;
}
.title3{
    margin-left:10px;    
    font-size: 30px;
    font-style: italic;
    color: #B3DDFF;
    font-weight: bold;
    background: linear-gradient(0deg, #F5A418 0%, #EA7A24 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    padding-right:4px
}

.tr{
    width:100%;
    padding: 0 10px 10px 10px;
    flex-wrap:wrap;
    overflow: hidden;
    .scroll_wrapper{
        //transition-timing-function: linear;
        display: flex;
        flex-wrap: wrap;
        width: 100%
    }
    .tr_item_wrapper{
        box-shadow:0 0 5px #008cff inset; 
        margin:0 1% 10px 1%;
        height:40px;
        line-height: 40px;
        padding:0 10px;
        width:48%;
        box-sizing: border-box;
    }
    .tr_item_title1{
        font-size: 14px;
        color: #B3DDFF;
    }
    .tr_item_title2{
        font-size: 18px;
        font-style: italic;
        font-weight: bold;
        color: #B3DDFF;
        background: linear-gradient(0deg, #00A8FF 10.205078125%, #4CECFF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        padding-right:4px
    }
    .tr_item_title3{
        font-size: 14px;
        font-style: italic;
        color: #B3DDFF;
        background: linear-gradient(0deg, #00A8FF 10.205078125%, #4CECFF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
}
</style>